import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { Camera } from '../../../models/Camera';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Document } from '../../../models/Document';
import { SwiperComponent } from "swiper/angular";
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper";
import { GlobalMethodsService } from '../../../services/global-methods.service';
import { DefaultModalComponent } from '../default-modal/default-modal.component';
import { Plugins } from '@capacitor/core';
import { FileSharer } from '@byteowls/capacitor-filesharer';
SwiperCore.use([Autoplay, Pagination, Navigation]);
@Component({
  selector: 'app-photos-cameras',
  templateUrl: './photos-cameras.component.html',
  styleUrls: ['./photos-cameras.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class PhotosCamerasComponent implements OnInit {

  @Input('format') format: string;
  @Input('resources') resources: Document[];
  @Input('descCamera') descCamera: string;
  @Input('camera') camera: Camera;
  @ViewChild('video') video: ElementRef;

  public modal_title: string;
  public modal_subtitle: string;
  public showVideo: boolean = false;
  public pressedMute: boolean;
  public pressedShare: boolean;
  public pressedDownload: boolean;
  public pressedPlay: boolean;
  public pressedPause: boolean;
  public canBeShared = false;

  public videoUrl: string;
  public picUrl = [];
  public swiper: SwiperCore;

  constructor(private modalCtrl: ModalController,
    private translate: TranslateConfigService,
    private socialSharing: SocialSharing,
    private platform: Platform,
    private iab: InAppBrowser,
    public gms: GlobalMethodsService,
    private defaultModalComponent: DefaultModalComponent,
  ) { }

  async ngOnInit() {
    //this.gms.loading();
    if (this.format == 'FOTOS') {
      this.modal_title = await this.translate.getTranslate('CAMERAS.photosCamerasComponent.titlePhoto');
      this.modal_subtitle = this.descCamera;
      this.canBeShared = this.resources[0].doc_url.indexOf('http://') !== -1 || this.resources[0].doc_url.indexOf('https://') !== -1 || this.resources[0].doc_url === '' ? false : true;
      this.resources.forEach(picture => {
        if (picture.doc_url.indexOf('http://') !== -1 || picture.doc_url.indexOf('https://') !== -1) {
          this.picUrl.push(picture.doc_url + '.jpg');
        }
        else {
          if (picture.doc_url != '') {
            let urlRec = picture.doc_url;
            let url64 = `data:image/jpg;base64,${urlRec}`;
            this.picUrl.push(url64);
          }
        }
      })
      this.pressedPlay = true;
    } else if (this.format == 'VIDEO') {
      this.canBeShared = this.resources[0].doc_url.indexOf('http://') !== -1 || this.resources[0].doc_url.indexOf('https://') !== -1 || this.resources[0].doc_url === '' ? false : true;
      if (this.resources[0].doc_url.indexOf('http://') !== -1 || this.resources[0].doc_url.indexOf('https://') !== -1){
        this.videoUrl = this.resources[0].doc_url + ".mp4";
      }
      else{
        let urlRec = this.resources[0].doc_url;
        this.videoUrl = `data:video/mp4;base64,${urlRec}`
      }
      this.modal_title = await this.translate.getTranslate('CAMERAS.photosCamerasComponent.titleVideo');
      this.modal_subtitle = this.descCamera;
      this.showVideo = true;
    }
  }

  ionViewWillEnter(){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Foto Camara', contentGroup: 'Camaras'});
  }

  ionViewDidEnter() {
    if(this.format === 'FOTOS'){
      this.swiper = new SwiperCore('.swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        speed: 0,
        loop: false,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          disableOnInteraction: true,
          delay: 700,
        }
      });
      this.swiper.init();
      this.swiper.autoplay.start();
    }
  }

  play() {
    this.pressedPlay = !this.pressedPlay;
    if (this.pressedPlay) {
      this.swiper.autoplay.start();
      this.pressedPause = false;
    } else {
      this.pause();
    }
  }

  pause() {
    this.pressedPause = !this.pressedPause;
    if (this.pressedPause) {
      this.swiper.autoplay.stop();
      this.pressedPlay = false;
    } else {
      this.play();
    }
  }

  dismiss(value) {
    this.modalCtrl.dismiss({ confirm: value });
  }

  async share() {
    // let base64Data = "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";
    let contentType = this.format === 'FOTOS' ? 'image/jpg' : 'video/mp4';
    let format = this.format === 'FOTOS' ? '.jpg' : '.mp4';
    let base64Data = this.resources[0].doc_url;
    let currentDate = new Date();
    let currentDay = currentDate.getDate();
    let formattedCurrentDay = currentDay < 10 ? '0' + currentDay : currentDay;
    let currentMonth = currentDate.getMonth() + 1;
    let formattedCurrentMonth = currentMonth < 10 ? '0' + currentMonth : currentMonth;
    let currentYear = currentDate.getFullYear();
    let currentHour = currentDate.getHours();
    let formattedCurrentHour = currentHour < 10 ? '0' + currentHour : currentHour;
    let currentMinutes = currentDate.getUTCMinutes();
    let formattedCurrentMinutes = currentMinutes < 10 ? '0' + currentMinutes : currentMinutes;
    let currentSeconds = currentDate.getSeconds();
    let formattedCurrentSeconds = currentSeconds < 10 ? '0' + currentSeconds : currentSeconds;
    FileSharer.share({
      filename: 'ImagenSICOR-' + formattedCurrentDay + '-' + formattedCurrentMonth + '-' + currentYear + '-' + formattedCurrentHour + '-' + formattedCurrentMinutes + '-' + formattedCurrentSeconds + format,
      base64Data: base64Data,
      contentType: contentType
    })

    /*if(await this.platform.is('cordova')){
      const options = {
        chooserTitle: await this.translate.getTranslate('MESSAGES.chooseOptionShare'),
        url: this.url
      };
      this.socialSharing.shareWithOptions(options);
    }else{
      navigator.share({
        'title': await this.translate.getTranslate('MESSAGES.chooseOptionShare'),
        'url': this.url
      }).then(function() {
        console.log('Successful share');
      }).catch(function(error) {
        console.log('Error sharing:', error)
      });
    }*/
  }

  async download() {
    this.pressedDownload = !this.pressedDownload;
    //this.iab.create(this.url, '_system');
  }

  mute() {
    this.pressedMute = !this.pressedMute;
    this.video.nativeElement.muted = !this.video.nativeElement.muted;
  }
}
